import React from "react";
import { ReportsHeader } from "../ScoutingReports/ScoutingReports.styles";
import FavouriteReportsCard from "../../components/FavouriteReports/FavouriteReportsCard";
import helmetSrc from "../../assets/img/helmetScout.png";

const favouriteReportsCardData = [
  {
    imageUrl: helmetSrc,
    tag: "QB",
    school: "Georgia",
    position: "QB",
    goals: "10",
    assists: "5",
    minutes: "90",
    cups: "4",
    playerName: "John Doe",
  },
  {
    imageUrl: helmetSrc,
    tag: "QB",
    school: "Georgia",
    position: "QB",
    goals: "10",
    assists: "5",
    minutes: "90",
    cups: "4",
    playerName: "John Doe",
  },
  {
    imageUrl: helmetSrc,
    tag: "QB",
    school: "Georgia",
    position: "QB",
    goals: "10",
    assists: "5",
    minutes: "90",
    cups: "4",
    playerName: "John Doe",
  },
  {
    imageUrl: helmetSrc,
    tag: "QB",
    school: "Georgia",
    position: "QB",
    goals: "10",
    assists: "5",
    minutes: "90",
    cups: "4",
    playerName: "John Doe",
  },
  {
    imageUrl: helmetSrc,
    tag: "QB",
    school: "Georgia",
    position: "QB",
    goals: "10",
    assists: "5",
    minutes: "90",
    cups: "4",
    playerName: "John Doe",
  },
  {
    imageUrl: helmetSrc,
    tag: "QB",
    school: "Georgia",
    position: "QB",
    goals: "10",
    assists: "5",
    minutes: "90",
    cups: "4",
    playerName: "John Doe",
  },
  {
    imageUrl: helmetSrc,
    tag: "QB",
    school: "Georgia",
    position: "QB",
    goals: "10",
    assists: "5",
    minutes: "90",
    cups: "4",
    playerName: "John Doe",
  },
  {
    imageUrl: helmetSrc,
    tag: "QB",
    school: "Georgia",
    position: "QB",
    goals: "10",
    assists: "5",
    minutes: "90",
    cups: "4",
    playerName: "John Doe",
  },
];

const FavouriteReports = () => {
  return (
    <div
      style={{
        overflow: "hidden",
        width: "81%",
        margin: "auto",
        marginTop: "50px",
      }}
    >
      <ReportsHeader>
        <div className={"blockTitle"}>Favourite Reports</div>
      </ReportsHeader>
      <div
        style={{
          display: "flex",
          gap: "1.5rem",
          flexWrap: "wrap",
          justifyContent: "center",
          marginBottom: "50px",
        }}
      >
        {favouriteReportsCardData.map((item, index) => (
          <FavouriteReportsCard
            key={index}
            imageUrl={item.imageUrl}
            tag={item.tag}
            school={item.school}
            position={item.position}
            goals={item.goals}
            assists={item.assists}
            minutes={item.minutes}
            cups={item.cups}
            playerName={item.playerName}
          />
        ))}
      </div>
    </div>
  );
};

export default FavouriteReports;
